/*
 * @Author: your name
 * @Date: 2021-11-17 14:45:16
 * @LastEditTime: 2021-11-17 15:17:19
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/utils/global.js
 */
import { judgmentPlatform, checkIsApp, whatEev } from './tools';

let terminalMark = 1; // 下单终端： 1 H5 2 PC 3 IOS-App 4 Android-App 5 IOS-PAD 6 Android-PAD 7 其他 9 HarmonyOS-app
let userTerminal = 5; /// / 终端: 1 ios、2 andriod、3 pad、4 PC、5 H5 6 HarmonyOS
(() => {
  if (whatEev() === 'miniprogram') {
    terminalMark = 8;
    userTerminal = 5;
  } else if (!checkIsApp()) {
    terminalMark = 1;
    userTerminal = 5;
  } else if (judgmentPlatform() === 'android') {
    terminalMark = 4;
    userTerminal = 2;
  } else if (judgmentPlatform() === 'ios') {
    terminalMark = 3;
    userTerminal = 1;
  } else if (judgmentPlatform() === 'HarmonyOS') {
    terminalMark = 9;
    userTerminal = 6;
  }
})();

const OSS_IMAGE_PREFIX = 'https://iqh-zt-pord-cdn.iqihang.com';

const PHONEPATTEN = /^1(3|4|5|6|7|8|9)\d{9}$/;

export default {
  terminalMark,
  userTerminal,
  OSS_IMAGE_PREFIX,
  PHONEPATTEN,
};
